export default __webpack_public_path__ + "static/media/Check.e918dc21.svg";